import getConfig from "next/config";

import LoginModal from "@components/LoginModal";
import RegisterModal from "@components/RegisterModal";
import ResetPassModal from "@components/ResetPassModal";
import ModalErrorBoundary from "@containers/ModalErrorBoundary";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ProductReviewsFormPlaceholder = ({
  addModal,
  label,
  showLogin = true,
  type,
}) => {
  const loginModalId = `add-modal-${
    type === "reviews" ? "recenzii" : "intrebari"
  }`;
  const registerModalId = `register-modal-${
    type === "reviews" ? "recenzii" : "intrebari"
  }`;
  const resetPassModalId = `reset-pass-modal-${
    type === "reviews" ? "recenzii" : "intrebari"
  }`;

  return (
    <div className="md:w-1/2 mx-auto py-6 text-center">
      <p className="mb-10">
        <img
          src={`${settings.websiteStatics}/images/quotes.svg`}
          className="inline align-top"
          alt=""
        />

        <span className="text-2xl -tracking-0.5 leading-31.2 font-light">
          {label}
        </span>

        <img
          src={`${settings.websiteStatics}/images/quotes.svg`}
          className="inline align-bottom"
          alt=""
        />
      </p>

      {showLogin && (
        <>
          <button
            type="button"
            onClick={() => addModal(loginModalId)}
            className="text-sm text-red-brand hover:text-bleu-hover underline"
          >
            Intra in cont
          </button>

          <br></br>

          <button
            type="button"
            onClick={() => addModal(registerModalId)}
            className="text-sm text-red-brand hover:text-bleu-hover underline"
          >
            Creeaza cont nou
          </button>

          <ModalErrorBoundary>
            <LoginModal
              location={`pop-up-${
                type === "reviews" ? "recenzii" : "intrebari"
              }`}
              modalId={loginModalId}
              registerModalId={registerModalId}
              resetPassModalId={resetPassModalId}
            />
          </ModalErrorBoundary>

          <ModalErrorBoundary>
            <ResetPassModal modalId={resetPassModalId} />
          </ModalErrorBoundary>

          <ModalErrorBoundary>
            <RegisterModal
              modalId={registerModalId}
              loginModalId={loginModalId}
            />
          </ModalErrorBoundary>
        </>
      )}
    </div>
  );
};

export default ProductReviewsFormPlaceholder;
